import styles from './Header.module.css'

const Header = () => {
  return (
    <div className={styles.header}>
      <h2 className={styles.title}>Customer Licenses</h2>
    </div>
  )
}

export default Header
